import { LandingFooter } from "@/components/public/LandingFooter"
import { PaymentModels } from "@/components/public/PaymentModels"
import { PublicHeader } from "@/components/public/PublicHeader"
import { RoutesDiagram } from "@/components/public/RoutesDiagram"
import { BreathingGradient } from "@/components/ui/living-brand"
import { Reveal } from "@/components/ui/Reveal"
import { Heading, Text } from "@/components/ui/typography"
import { cn } from "@/lib/utils"
import { semanticTokens } from "@packages/config/theme"
import { Page } from "@supabank/ui"
import { useTranslation } from "react-i18next"

export default function HowPaymentsWorkPage() {
  const { t } = useTranslation("marketing")

  return (
    <Page data-ux-contract="canon" role="main" className="bg-background text-foreground">
      {/* Unified PublicHeader component */}
      <PublicHeader />

      <main className="space-y-0" id="main">
        <div className={cn(
          "relative overflow-hidden py-12 sm:py-16 md:py-20",
          // CANON: Hero gradient background (lavenderGlow for fintech feel)
          semanticTokens.heroGradient.lavenderGlow.tailwind,
          // Dark mode variant
          "dark:bg-black dark:bg-[radial-gradient(ellipse_at_20%_50%,hsla(270,95%,75%,0.08)_0%,transparent_50%),radial-gradient(ellipse_at_80%_80%,hsla(217,91%,60%,0.06)_0%,transparent_50%),hsl(var(--background))]"
        )}>
          {/* Living Brand: Breathing Gradient (syncs with LED heartbeat) - DISABLED on dark theme */}
          <BreathingGradient
            variant="lavender"
            syncWithLed
            className="absolute inset-0 z-[1] pointer-events-none opacity-30 dark:hidden"
          />
          <div className="relative z-10 space-y-12">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 mb-12 text-center">
              <Heading level={1} className="mb-4">
                {t("stepsSection.headline")} {t("stepsSection.headlineHighlight")}
              </Heading>
              <Text variant="lg" color="muted" className="max-w-2xl mx-auto">
                {t("stepsSection.description")}
              </Text>
            </div>

            <Reveal>
              <PaymentModels id="use-cases" />
            </Reveal>

            <Reveal delay={0.1}>
              <RoutesDiagram id="routes" />
            </Reveal>
          </div>
        </div>
      </main>

      <LandingFooter />
    </Page>
  )
}
